import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EmpresaService } from 'src/app/services/empresa.service';
interface Rol {
  label: string;
  value: number;
}
@Component({
  selector: 'app-empresa-form',
  templateUrl: './empresa-form.component.html',
  styleUrls: ['./empresa-form.component.scss'],
  providers: [MessageService]
})
export class EmpresaFormComponent implements OnInit {
  public usuarioForm: FormGroup;
  roles: Rol[];

  constructor(private fb: FormBuilder, private empresaService: EmpresaService, private messageService: MessageService) {
    this.roles = [
      { label: 'Administrador', value: 1 },
      { label: 'Empresa', value: 2 }
    ];

    this.usuarioForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      contrasena: ['', [Validators.required, Validators.minLength(6)]],
      nombre: ['', Validators.required],
      rfc: ['', [Validators.required, Validators.maxLength(13), Validators.pattern('[A-ZÑ&]{3,4}[0-9]{6}[A-Z0-9]{3}')]],
      entidad_federativa: ['', Validators.required],
      codigo_postal: ['', [Validators.pattern('^[0-9]{5}$')]],
      nombre_contacto: ['', Validators.required],
      telefono: ['', [Validators.required, Validators.pattern('^[0-9]{10,13}$')]],
      fk_rol: [2, Validators.required]
    });
  }

  ngOnInit() { }

  get f() {
    return this.usuarioForm.controls;
  }

  onSubmit() {
    if (this.usuarioForm.invalid) {
      this.usuarioForm.markAllAsTouched();
      return;
    }
    // aquí enviarías this.usuarioForm.value al backend
    console.log('Formulario válido:', this.usuarioForm.getRawValue());

    this.empresaService.create(this.usuarioForm.getRawValue())
      .subscribe({
        next: (resp) => { this.showSuccess(resp.mensaje); },
        error: (err) => { this.showWarning(err.mensaje); }
      })
  }
  showSuccess(msg: string): void {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: msg });
  }
  showWarning(msg: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Nota!!', detail: msg });
  }
}
